// Service API pour la télémaintenance
import { getAuthHeaders } from './authUtils';

const API_BASE = '/api/telemaintenance';

export const teleMaintenance = {
  // Tester la configuration SMTP
  async testConnection() {
    try {
      const response = await fetch(`${API_BASE}/test`, {
        method: 'GET',
        headers: getAuthHeaders()
      });
      
      if (!response.ok) {
        throw new Error('Erreur lors du test de connexion SMTP');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Erreur test SMTP:', error);
      throw error;
    }
  },

  // Récupérer les templates par défaut
  async getTemplates() {
    try {
      const response = await fetch(`${API_BASE}/templates`, {
        method: 'GET',
        headers: getAuthHeaders()
      });
      
      if (!response.ok) {
        throw new Error('Erreur lors de la récupération des templates');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Erreur récupération templates:', error);
      throw error;
    }
  },

  // Envoyer une demande de télémaintenance
  async sendRequest(clientId, requestData) {
    try {
      const response = await fetch(`${API_BASE}/send`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...getAuthHeaders()
        },
        body: JSON.stringify({
          clientId,
          requestData
        })
      });
      
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Erreur lors de l\'envoi de la demande');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Erreur envoi télémaintenance:', error);
      throw error;
    }
  },

  // Récupérer l'historique des demandes pour un client
  async getHistory(clientId) {
    try {
      const response = await fetch(`${API_BASE}/history/${clientId}`, {
        method: 'GET',
        headers: getAuthHeaders()
      });
      
      if (!response.ok) {
        throw new Error('Erreur lors de la récupération de l\'historique');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Erreur récupération historique:', error);
      throw error;
    }
  }
};

// Templates par défaut côté client (pour la prévisualisation)
export const teleMaintenance_Templates = {
  generic: {
    name: "Demande générique",
    content: "Bonjour,\n\nPouvez-vous ouvrir la télémaintenance pour le compte \"{ACCOUNT_NAME}\" ce jour ?\n\nMerci !\n\nCordialement",
    variables: ['ACCOUNT_NAME']
  },
  problem: {
    name: "Intervention sur problème",  
    content: "Bonjour,\n\nPouvez-vous ouvrir la télémaintenance pour le compte \"{ACCOUNT_NAME}\" ce jour afin d'intervenir sur {REASON} ?\n\nMerci !\n\nCordialement",
    variables: ['ACCOUNT_NAME', 'REASON']
  },
  update: {
    name: "Montée de version",
    content: "Bonjour,\n\nPouvez-vous ouvrir la télémaintenance ce jour pour le compte \"{ACCOUNT_NAME}\" afin de réaliser la montée de version de l'environnement de production ( {VERSION} ) ?\n\nMerci !\n\nCordialement", 
    variables: ['ACCOUNT_NAME', 'VERSION']
  },
  custom: {
    name: "Template personnalisé",
    content: "",
    variables: ['CLIENT_NAME', 'ACCOUNT_NAME', 'REASON', 'VERSION', 'DATE']
  }
};

// Fonction pour prévisualiser le contenu d'un template avec des variables
export function previewTemplate(template, variables = {}) {
  let content = template;
  
  const defaultVars = {
    '{CLIENT_NAME}': variables.clientName || '[NOM_CLIENT]',
    '{ACCOUNT_NAME}': variables.accountName || '[COMPTE]', 
    '{REASON}': variables.reason || '[RAISON]',
    '{VERSION}': variables.version || '[VERSION]',
    '{DATE}': new Date().toLocaleDateString('fr-FR')
  };
  
  Object.entries(defaultVars).forEach(([key, value]) => {
    content = content.replace(new RegExp(key.replace(/[{}]/g, '\\$&'), 'g'), value);
  });
  
  return content;
}
